import { Pagination } from "@mui/material";
import "./PaginateRecords.scss";

export default function PaginateRecords({
  color,
  totalPageCount,
  size,
  page,
  onPageClick,
  showFirstButton = true,
  showLastButton = true,
  disabled = false,
  ...otherProps
}) {
  return (
    <div className="pagination-container">
      <Pagination
        disabled={disabled}
        count={totalPageCount}
        size={size}
        page={page}
        onChange={onPageClick}
        variant="outlined"
        sx={{
          "& .MuiPaginationItem-root": {
            gap: "8px",
            color: { color },
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            color: "#fff",
            backgroundColor: "#51515F",
          },
          "& .MuiPaginationItem-root.Mui-selected:hover": {
            backgroundColor: "#51515F",
          },
          "& .MuiPagination-ul": {
            gap: "8px",
          },
        }}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
      />
    </div>
  );
}
